import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

export interface DocumentCommentsState {
    commentsData: any,
    atRateUserData: any,
    response: any,
    imagePath: any,
    profileImagePath: any,
    isFetching: boolean,
    isCommentDataSuccess: boolean,
    isAddResponse: boolean,
    isError: boolean,
    errorMessage: any,
    isAtrateSuccess: boolean,
}


const initialState: DocumentCommentsState = {
    commentsData: [],
    atRateUserData: [],
    response: [],
    imagePath: '',
    profileImagePath: '',
    isFetching: false,
    isCommentDataSuccess: false,
    isAddResponse: false,
    isError: false,
    errorMessage: '',
    isAtrateSuccess: false,
};

export const getDocumentComments: any = createAsyncThunk(
    'documents/comments',
    async (udata, thunkAPI) => {
        try {
            const { auth }: any = thunkAPI.getState()
            let tokenStr = auth.user.token;

            let response = await axios({
                url: `/api/comment/comment?docId=${udata}&isHighLight=false`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            let error: any = err;
            if (!error.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
);



export const getAtrateUsernameAsyn: any = createAsyncThunk(
    'documents/comments/tagUser?',
    async (udata, thunkAPI) => {
        try {
            const { auth }: any = thunkAPI.getState()
            let tokenStr = auth.user.token;

            let response = await axios({
                url: `/api/comment/tagUser?document_uuid=${udata}`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            let error: any = err;
            if (!error.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
);


export const DocumentCommentsSlice = createSlice({
    name: 'documentcomments',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setAddState: (state, { payload }) => {
            state.isAddResponse = true;
            state.response = payload.data;
        },
        unsetAddState: (state) => {
            state.isAddResponse = false;
        },
        clearStateSlice: (state, { payload }: PayloadAction) => {
            // state.stageData = [];
            state.isFetching = false;
            state.isCommentDataSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.imagePath = '';
            // state.atRateUserData = [];
            // state.isAtrateSuccess = false;
        },
        clearStateAtRateUserName: (state, { payload }: PayloadAction) => {

            // state.atRateUserData = [];
            state.isAtrateSuccess = false;
        },

    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [getDocumentComments.fulfilled]: (state, { payload }) => {

            const { data } = payload.data;
            state.commentsData = data;
            state.imagePath = payload.data.imagePath;
            state.profileImagePath = payload.data.profileImagePath;
            state.isFetching = false;
            state.isCommentDataSuccess = true;
            return state;
        },

        [getDocumentComments.pending]: (state) => {
            state.isFetching = false;
        },

        [getDocumentComments.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },

        [getAtrateUsernameAsyn.fulfilled]: (state, { payload }) => {

            const { data } = payload;
            state.atRateUserData = data;
            state.isFetching = false;
            state.isAtrateSuccess = true;
            return state;
        },

        [getAtrateUsernameAsyn.pending]: (state) => {
            state.isFetching = false;
        },

        [getAtrateUsernameAsyn.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },


    },
});

export const { setAddState, unsetAddState, clearStateSlice, clearStateAtRateUserName } = DocumentCommentsSlice.actions;

export function clearState() {

    return async (dispatch: any) => {
        dispatch(clearStateSlice());
    };
}

export function clearAddResponseState() {

    return async (dispatch: any) => {
        dispatch(unsetAddState());
    }
}

export function clearAtRateUserNameState() {

    return async (dispatch: any) => {
        dispatch(clearStateAtRateUserName());
    }
}

export const AddCommentsAsyn = (bdata: any) => async (dispatch: any, getState: any) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.post('/api/comment/comment', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    //console.log(data.data)
    dispatch(setAddState(data));
    return data;
};

export const DeleteCommentsAsyn = (bdata: any) => async (dispatch: any, getState: any) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let response = await axios({
        url: `/api/comment/comment/`,
        method: 'delete',
        data: bdata,
        //timeout: 8000,
        headers: {
            //'Content-Type': 'application/json',
            "Authorization": `Bearer ${tokenStr}`
        }
    })
    let data = response.data;
    //console.log(data.data)
    return data;
};


export const DocumentCommentsSelector = (state: any) => state.documentcomments;

export default DocumentCommentsSlice.reducer;
